<template>
  <div id="eterminal-container">
    <v-row>
      <v-col lg="6" md="6" sm="12" xs="12" offset-lg="3" offset-md="3">
        <v-row>
          <v-col md="12">
            <v-card color="rgba(255, 255, 255, 1)">
              <v-card-title class="px-3">Payment Details</v-card-title>
              <v-divider></v-divider>
              <!-- <v-form ref="form" lazy-validation @submit="onSubmit"> -->
              <div class="px-4 py-2 pb-2">
                <v-row>
                  <v-col md="12" class="py-0">
                    <v-text-field
                      v-model="card.merchantTransactionId"
                      label="Reference"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6" class="py-0">
                    <v-text-field
                      v-model="card.amount"
                      label="Amount"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <v-select
                      v-model="card.currency"
                      :items="currencies"
                      :rules="[rules.required]"
                      label="Currency"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6" class="py-0">
                    <v-select
                      v-model="card.recurring"
                      :items="recurring"
                      label="Recurring Type"
                    ></v-select>
                  </v-col>

                  <v-col md="6" class="py-0">
                    <v-text-field
                      v-model="card.postcode"
                      label="Postcode"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="pb-2">
                  <v-col md="12" class="py-0">
                    <v-row>
                      <v-col md="12" class="py-0">
                        <form
                          ref="paymentForm"
                          v-if="host == 'localhost'"
                          action="http://localhost:3000/eterminal"
                          class="paymentWidgets"
                          data-brands="SOFORTUEBERWEISUNG"
                        ></form>
                        <form
                          ref="paymentForm"
                          v-else
                          action="https://control2.totalprocessing.com/eterminal"
                          class="paymentWidgets"
                          data-brands="SOFORTUEBERWEISUNG"
                        ></form>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="pb-0">
                  <v-col md="12" class="py-0" align="end">
                    <v-btn
                      v-if="!checkoutId"
                      :disabled="!validate"
                      color="primary"
                      type="buttn"
                      class="mb-2"
                      @click="onSubmit"
                      >Create Checkout</v-btn
                    >
                  </v-col>
                </v-row>
              </div>

              <!-- </v-form> -->
            </v-card>
          </v-col>
        </v-row>

        <!-- Result -->
        <v-row v-if="result && result.result.code == '000.000.000'">
          <v-col md="12" class="py-0">
            <v-alert type="success" text border="left" dismissible class="mb-2">
              Code: {{ result.result.code }}<br />
              Description: {{ result.result.description }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row
          v-else-if="result && result.result.code != '000.000.000'"
          class="px-4"
        >
          <v-col md="12" class="">
            <v-alert type="error" text border="left" dismissible>
              Code: {{ result.result.code }}<br />
              Description: {{ result.result.description }}
            </v-alert>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      card: {
        channel: null,
        merchantTransactionId: null,
        amount: null,
        currency: null,
        recurring: null,
        postcode: null,
      },
      checkoutId: null,
      currencies: [{ value: "GBP", text: "GBP" }],
      recurring: [
        { value: null, text: "NONE" },
        { value: "INITIAL", text: "INITIAL" },
        { value: "REPEATED", text: "REPEATED" },
      ],
      rules: {
        required: (v) => !!v || "Required.",
      },
      channels: [],
      transactionId: null,
      result: null,
      loading: false,
      host: window.location.hostname,
    };
  },
  computed: {
    uri() {
      return this.$store.state.sysState ? "live" : "test";
    },
    validate() {
      if (this.card.amount && this.card.currency) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    this.getChannels();
    if (this.$route.query.resourcePath) {
      this.getPaymentStatus();
    }
  },
  methods: {
    getChannels() {
      if (this.$store.state.user.user_role.id <= 3) {
        axios({
          method: "get",
          url: `get-channels-live`,
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          },
        })
          .then((response) => {
            response.data.map((e) => {
              let currencies = e.currencies.split(",");
              this.channels.push({
                uuid: e.channelUuid,
                name: `${e.merchantName} - ${e.channelName}`,
                currencies: currencies,
              });
            });
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else if (this.$store.state.user.user_role.id > 3) {
        axios({
          method: "post",
          url: `get-channels-live-client`,
          data: { userId: this.$store.state.user.id },
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          },
        })
          .then((response) => {
            response.data.map((e) => {
              let currencies = e.currencies.split(",");
              this.channels.push({
                uuid: e.channelUuid,
                name: `${e.merchantName} - ${e.channelName}`,
                currencies: currencies,
              });
            });
            this.channels.sort(this.compare);
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },
    onSubmit(e) {
      e.preventDefault();
      this.result = null;

      axios({
        method: "post",
        url: `sofort-test-checkout`,
        data: { card: this.card },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          var jq = document.createElement("script");
          jq.setAttribute(
            "src",
            "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"
          );
          document.head.appendChild(jq);

          const cnp = document.createElement("script");
          cnp.setAttribute("src", "https://dally.totalprocessing.com/cnp.js");
          document.head.appendChild(cnp);

          const cnpScript = document.createElement("script");
          this.checkoutId = response.data.id;
          console.log(this.checkoutId);
          console.log(response.data);
          cnpScript.setAttribute(
            "src",
            "https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=" +
              this.checkoutId
          );
          document.head.appendChild(cnpScript);
        })
        .then((response) => {})
        .catch((e) => {
          this.errors.push(e);
        });
    },
    compare(a, b) {
      const x = a.name.toUpperCase();
      const y = b.name.toUpperCase();

      let comparison = 0;
      if (x > y) {
        comparison = 1;
      } else if (x < y) {
        comparison = -1;
      }
      return comparison;
    },
    currencyHandle(a) {
      this.channels.find((e) => {
        if (e.uuid == a) {
          this.currencies = e.currencies;
        }
      });
    },
    getPaymentStatus() {
      let path = this.$route.query.resourcePath
        .replace("/v1/checkouts/", "")
        .replace("/payment", "");

      axios({
        method: "post",
        url: `get-payment-status-live`,
        data: { path: path },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          console.log(response.data);
          this.result = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>

<style scoped>
#eterminal-container {
  margin-left: -55px;
}

.card-items {
  font-family: "Courier New", Courier, monospace;
  font-weight: 600;
  fill: #fff;
}

.wpwl-form {
  margin: 0 !important;
  max-width: 100% !important;
}

.wpwl-control {
  border: none !important;
  background-color: inherit !important;
  color: #000 !important;
}

.wpwl-group-brand {
  display: none !important;
}

.wpwl-has-error ~ .wpwl-hint {
  color: #ff5252 !important;
  margin: 0;
  font-size: 12px;
  display: none;
}

.wpwl-container .v-messages__wrapper {
  color: #ff5252 !important;
  height: 18px !important;
}

.wpwl-group {
  margin-bottom: 0 !important;
}

#card-cvv-slot {
  margin-top: -2px !important;
}

#expiry-slot {
  margin-top: 2px !important;
}

.wpwl-wrapper {
  width: 100% !important;
}
</style>
